import { render, staticRenderFns } from "./PageWorldFun.vue?vue&type=template&id=6950158b&scoped=true&"
import script from "./PageWorldFun.vue?vue&type=script&lang=js&"
export * from "./PageWorldFun.vue?vue&type=script&lang=js&"
import style0 from "./PageWorldFun.vue?vue&type=style&index=0&id=6950158b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950158b",
  null
  
)

export default component.exports